import basicInformationActions from './basic-information/actions';
import educationActions from './education/actions';
import languagesActions from './languages/actions';
import motivatorsActions from './motivators/actions';
import projectsActions from './projects/actions';
import skillsActions from './skills/actions';
import workExperienceActions from './work-experience/actions';
import trainingsActions from './trainings/actions';

export default {
  ...basicInformationActions,
  ...workExperienceActions,
  ...educationActions,
  ...projectsActions,
  ...languagesActions,
  ...motivatorsActions,
  ...skillsActions,
  ...trainingsActions
};
